module.exports = __webpack_public_path__ + "img/6.e165e145.png";